import { motion } from "framer-motion";
import React from "react";
import { Link, useNavigate } from "react-router-dom";

const shapes = [
  { className: "w-16 h-16 top-[20%] left-[10%]", delay: 0 },
  { className: "w-20 h-20 top-[60%] right-[10%]", delay: 2 },
  { className: "w-10 h-10 bottom-[20%] left-[20%]", delay: 4 },
];

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-400 to-purple-700 text-white overflow-hidden">
      {/* Floating shapes */}
      <div className="absolute inset-0 z-0">
        {shapes.map((shape, i) => (
          <motion.div
            key={i}
            className={`shape absolute rounded-full bg-white bg-opacity-10 ${shape.className}`}
            animate={{ y: [0, -20, 0], rotate: [0, 180, 0] }}
            transition={{ duration: 6, repeat: Infinity, ease: "easeInOut", delay: shape.delay }}
          />
        ))}
      </div>

      <div className="container relative z-10 text-center p-8 max-w-xl w-full">
        <div className="icon mx-auto mb-8 opacity-80">
          <svg viewBox="0 0 24 24" fill="currentColor" className="w-28 h-28 mx-auto">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" opacity="0.3" />
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
          </svg>
        </div>
        <motion.div
          className="error-code font-bold mb-4 text-[6rem] md:text-[8rem] drop-shadow-lg"
          animate={{ y: [0, -20, 0] }}
          transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
        >
          404
        </motion.div>
        <h1 className="error-title text-3xl md:text-4xl font-bold mb-4 drop-shadow">Page Not Found</h1>
        <p className="error-message text-lg mb-8 opacity-90 leading-relaxed">
          Oops! The page you're looking for seems to have wandered off.<br />
          Don't worry, it happens to the best of us. Let's get you back on track.
        </p>
        <div className="actions flex gap-4 justify-center flex-wrap">
          <Link to="/" className="btn btn-primary px-6 py-3 rounded-lg font-semibold border-2 border-white bg-white bg-opacity-20 hover:bg-opacity-30 transition backdrop-blur">
            Go Home
          </Link>
          <button
            className="btn btn-secondary px-6 py-3 rounded-lg font-semibold border-2 border-white bg-transparent hover:bg-white hover:bg-opacity-10 transition"
            onClick={() => navigate(-1)}
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
